const getRandomNumbers = (numberOfRandoms, start, end) => {
  const arr = [];
  const min = Math.ceil(start);
  const max = Math.floor(end);
  while (arr.length < numberOfRandoms) {
    const r = Math.floor(Math.random() * (max - min + 1)) + min;
    if (arr.indexOf(r) === -1) arr.push(r);
  }
  return arr;
};

const commonUtils = { getRandomNumbers };

export default commonUtils;
